import { render } from "./TakesTblActions.vue?vue&type=template&id=52caf948&scoped=true"
import script from "./TakesTblActions.vue?vue&type=script&lang=js"
export * from "./TakesTblActions.vue?vue&type=script&lang=js"

import "./TakesTblActions.vue?vue&type=style&index=0&id=52caf948&scoped=true&lang=scss"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52caf948"]])

export default __exports__